import { createSlice } from '@reduxjs/toolkit'
import { fetchNavLinks } from './thunks'

type SidebarInitialState = {
	searchOptions: [] | { [key: string]: string }[]
	searchDefault: string | null
	searchPlaceholder: string | null
	loading: boolean
}

const initialState: SidebarInitialState = {
	searchOptions: [
		{
			text: 'Reservations',
			value: 'reservations',
		},
		{
			text: 'Invoices',
			value: 'invoices',
		},
		{
			text: 'Registrations',
			value: 'registrations',
		},
		{
			text: 'People',
			value: 'people',
		},
		{
			text: 'Damages',
			value: 'damages',
		},
		{
			text: 'Fines',
			value: 'fines',
		},
		{
			text: 'Businesses',
			value: 'businesses',
		},
	],
	searchDefault: '',
	searchPlaceholder: '',
	loading: false,
}

export const headerSlice = createSlice({
	name: 'header',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchNavLinks.rejected, state => {
			state.loading = false
		})
		builder.addCase(fetchNavLinks.pending, state => {
			state.loading = true
		})
		builder.addCase(fetchNavLinks.fulfilled, (state, action) => {
			const { searchOptions, searchDefault, searchPlaceholder } = action.payload
			state.searchOptions = searchOptions
			state.searchDefault = searchDefault
			state.searchPlaceholder = searchPlaceholder
			state.loading = false
		})
	},
})

export const selectHeader = state => state.header
export const headerSliceReducer = headerSlice.reducer
